// extracted by mini-css-extract-plugin
export const body = "accordion-module--body--3xPeu";
export const active = "accordion-module--active--1_6vO";
export const bar = "accordion-module--bar--2dx5D";
export const icon = "accordion-module--icon--37-Ed";
export const item = "accordion-module--item--frHaZ";